import { inject, Injectable } from '@angular/core';
import { GraphService } from './graph/graph.service';

@Injectable({
  providedIn: 'root'
})
export class StartupService {
  private readonly graphService = inject(GraphService);

  public async initializeServices() {
    await this.graphService.saveGraphUserData();
  }
}
